var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorBottom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 363,
    viewBox: "0 0 476 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.038 5.5C468.994 5.50011 602.576 137.206 602.576 299.5C602.576 461.794 468.994 593.5 304.038 593.5C139.082 593.5 5.5 461.794 5.5 299.5C5.5 137.206 139.082 5.5 304.038 5.5Z",
    stroke: "white",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorBottom2);
export default __webpack_public_path__ + "static/media/vector-bottom-2.19071825c9b50f67a681886dfddf1285.svg";
export { ForwardRef as ReactComponent };